__turbopack_context__.v({
  "root": "Animation-module-scss-module__HTrA_q__root",
});
